import WorkOrdersListModal from '@/components/_common/WorkOrdersListModal';
import { useDisclosure } from '@/hooks';
import { DateTimeFormat } from '@/utils/moment';
import moment from 'moment';
import {
  StatisticDashboardModule,
  StatisticDashboardTypeColor,
} from '@/components/_common/StatisticDashboard';
import DashboardStatisticCard from '../../DashboardStatisticCard';

interface Props {
  value?: number;
}

function MonthlyDeliveries({ value }: Props) {
  const [viewWorkOrdersOpen, viewWorkOrdersActions] = useDisclosure();

  return (
    <>
      <DashboardStatisticCard
        tooltipTitle="Quantidade de orçamentos com data de saída prevista para o mês atual"
        statisticTitle={`Entregas para ${moment().format('MMMM')}`}
        color={StatisticDashboardTypeColor.info}
        value={value}
        module={StatisticDashboardModule.workOrder}
        onClick={viewWorkOrdersActions.open}
      />

      <WorkOrdersListModal
        open={viewWorkOrdersOpen}
        onCancel={viewWorkOrdersActions.close}
        queryFilter={{
          estimatedLeaveInitialDate: moment()
            .startOf('month')
            .format(DateTimeFormat),
          estimatedLeaveFinalDate: moment()
            .endOf('month')
            .format(DateTimeFormat),
        }}
      />
    </>
  );
}

export default MonthlyDeliveries;
